import { SpatialNavigation } from '@accedo/spatial-nav';

export const nav = new SpatialNavigation();
